import {
        CREATEPEDIATRICOPDSETTINGCOMPLAINTBASICPROBLEM,
        CREATEPEDIATRICOPDSETTINGCOMPLAINTDELIVERYTYPE,
        CREATEPEDIATRICOPDSETTINGCOMPLAINTFEEDINGSUPPLEMENT,
        CREATEPEDIATRICOPDSETTINGCOMPLAINTFIRSTCRY,
        CREATEPEDIATRICOPDSETTINGCOMPLAINTMILESTONE,
        CREATEPEDIATRICOPDSETTINGCOMPLAINTMILESTONEAGEGROUP,
        CREATEPEDIATRICOPDSETTINGCOMPLAINTPROCEDURES,
        CREATEPEDIATRICOPDSETTINGCOMPLAINTSILLNESSDURINGPEGNANCY,
        CREATEPEDIATRICOPDSETTINGCOMPLAINTSINFECTIONDURINGPEGNANCY,
        CREATEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRY,
        CREATEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRYTYPE,
        CREATEPEDIATRICOPDSETTINGEXAMINATIONGENERALAPPEARANCE,
        CREATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINNATURE,
        CREATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINONSET,
        CREATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINVARIATION,
        CREATEPEDIATRICOPDSETTINGPAINASSESSMENTSEVERITY,
        CREATEPEDIATRICOPDSETTINGPAINASSESSMENTSTATUS,
        DELETEPEDIATRICOPDSETTINGCOMPLAINTBASICPROBLEM,
        DELETEPEDIATRICOPDSETTINGCOMPLAINTDELIVERYTYPE,
        DELETEPEDIATRICOPDSETTINGCOMPLAINTFEEDINGSUPPLEMENT,
        DELETEPEDIATRICOPDSETTINGCOMPLAINTFIRSTCRY,
        DELETEPEDIATRICOPDSETTINGCOMPLAINTMILESTONEAGEGROUP,
        DELETEPEDIATRICOPDSETTINGCOMPLAINTPROCEDURES,
        DELETEPEDIATRICOPDSETTINGCOMPLAINTSILLNESSDURINGPEGNANCY,
        DELETEPEDIATRICOPDSETTINGCOMPLAINTSINFECTIONDURINGPEGNANCY,
        DELETEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRY,
        DELETEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRYTYPE,
        DELETEPEDIATRICOPDSETTINGEXAMINATIONGENERALAPPEARANCE,
        DELETEPEDIATRICOPDSETTINGPAINASSESSMENTPAINNATURE,
        DELETEPEDIATRICOPDSETTINGPAINASSESSMENTPAINONSET,
        DELETEPEDIATRICOPDSETTINGPAINASSESSMENTPAINVARIATION,
        DELETEPEDIATRICOPDSETTINGPAINASSESSMENTSEVERITY,
        DELETEPEDIATRICOPDSETTINGPAINASSESSMENTSTATUS,
        DELETEPEDIATRICOPDSETTINGCOMPLAINTMILESTONE,
        GETPEDIATRICOPDSETTINGCOMPLAINTBASICPROBLEM,
        GETPEDIATRICOPDSETTINGCOMPLAINTDELIVERYTYPE,
        GETPEDIATRICOPDSETTINGCOMPLAINTFEEDINGSUPPLEMENT,
        GETPEDIATRICOPDSETTINGCOMPLAINTFIRSTCRY,
        GETPEDIATRICOPDSETTINGCOMPLAINTMILESTONE,
        GETPEDIATRICOPDSETTINGCOMPLAINTMILESTONEAGEGROUP,
        GETPEDIATRICOPDSETTINGCOMPLAINTPROCEDURES,
        GETPEDIATRICOPDSETTINGCOMPLAINTSILLNESSDURINGPEGNANCY,
        GETPEDIATRICOPDSETTINGCOMPLAINTSINFECTIONDURINGPEGNANCY,
        GETPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRY,
        GETPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRYTYPE,
        GETPEDIATRICOPDSETTINGEXAMINATIONGENERALAPPEARANCE,
        GETPEDIATRICOPDSETTINGPAINASSESSMENTPAINNATURE,
        GETALLPEDIATRICOPDSETTINGINVESTIGATION,
        GETPEDIATRICOPDSETTINGPAINASSESSMENTPAINONSET,
        GETPEDIATRICOPDSETTINGPAINASSESSMENTPAINVARIATION,
        GETPEDIATRICOPDSETTINGPAINASSESSMENTSEVERITY,
        GETPEDIATRICOPDSETTINGPAINASSESSMENTSTATUS,
        UPDATEPEDIATRICOPDSETTINGCOMPLAINTBASICPROBLEM,
        UPDATEPEDIATRICOPDSETTINGCOMPLAINTDELIVERYTYPE,
        UPDATEPEDIATRICOPDSETTINGCOMPLAINTFEEDINGSUPPLEMENT,
        UPDATEPEDIATRICOPDSETTINGCOMPLAINTFIRSTCRY,
        UPDATEPEDIATRICOPDSETTINGCOMPLAINTMILESTONEAGEGROUP,
        UPDATEPEDIATRICOPDSETTINGCOMPLAINTPROCEDURES,
        UPDATEPEDIATRICOPDSETTINGCOMPLAINTSILLNESSDURINGPEGNANCY,
        UPDATEPEDIATRICOPDSETTINGCOMPLAINTSINFECTIONDURINGPEGNANCY,
        UPDATEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRY,
        UPDATEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRYTYPE,
        UPDATEPEDIATRICOPDSETTINGEXAMINATIONGENERALAPPEARANCE,
        UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINNATURE,
        UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINONSET,
        UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINVARIATION,
        UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTSEVERITY,
        UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTSTATUS,
        UPDATEPEDIATRICOPDSETTINGCOMPLAINTMILESTONE,
        CREATEPEDIATRICOPDSETTINGCOMPLAINTPASTILLNESSES,
        GETPEDIATRICOPDSETTINGCOMPLAINTPASTILLNESSES,
        UPDATEPEDIATRICOPDSETTINGCOMPLAINTPASTILLNESSES,
        DELETEPEDIATRICOPDSETTINGCOMPLAINTPASTILLNESSES,
        CREATEPEDIATRICOPDSETTINGCOMPLAINTDIET,
        GETPEDIATRICOPDSETTINGCOMPLAINTDIET,
        UPDATEPEDIATRICOPDSETTINGCOMPLAINTDIET,
        DELETEPEDIATRICOPDSETTINGCOMPLAINTDIET,
        CREATEPEDIATRICOPDSETTINGCOMPLAINTAPPETITE,
        GETPEDIATRICOPDSETTINGCOMPLAINTAPPETITE,
        UPDATEPEDIATRICOPDSETTINGCOMPLAINTAPPETITE,
        DELETEPEDIATRICOPDSETTINGCOMPLAINTAPPETITE,
        CREATEPEDIATRICOPDSETTINGCOMPLAINTDIGESTIVETRACT,
        GETPEDIATRICOPDSETTINGCOMPLAINTDIGESTIVETRACT,
        UPDATEPEDIATRICOPDSETTINGCOMPLAINTDIGESTIVETRACT,
        DELETEPEDIATRICOPDSETTINGCOMPLAINTDIGESTIVETRACT,
        CREATEPEDIATRICOPDSETTINGCOMPLAINTBOWEL,
        GETPEDIATRICOPDSETTINGCOMPLAINTBOWEL,
        UPDATEPEDIATRICOPDSETTINGCOMPLAINTBOWEL,
        DELETEPEDIATRICOPDSETTINGCOMPLAINTBOWEL,
        CREATEPEDIATRICOPDSETTINGCOMPLAINTSLIP,
        GETPEDIATRICOPDSETTINGCOMPLAINTSLIP,
        UPDATEPEDIATRICOPDSETTINGCOMPLAINTSLIP,
        DELETEPEDIATRICOPDSETTINGCOMPLAINTSLIP,
        CREATEPEDIATRICOPDSETTINGCOMPLAINTPOSITIONDURINGWORK,
        GETPEDIATRICOPDSETTINGCOMPLAINTPOSITIONDURINGWORK,
        UPDATEPEDIATRICOPDSETTINGCOMPLAINTPOSITIONDURINGWORK,
        DELETEPEDIATRICOPDSETTINGCOMPLAINTPOSITIONDURINGWORK,
        CREATEPEDIATRICOPDSETTINGCOMPLAINTNATURE,
        GETPEDIATRICOPDSETTINGCOMPLAINTNATURE,
        UPDATEPEDIATRICOPDSETTINGCOMPLAINTNATURE,
        DELETEPEDIATRICOPDSETTINGCOMPLAINTNATURE,
        CREATEPEDIATRICOPDSETTINGCOMPLAINTRELETION,
        GETPEDIATRICOPDSETTINGCOMPLAINTRELETION,
        UPDATEPEDIATRICOPDSETTINGCOMPLAINTRELETION,
        DELETEPEDIATRICOPDSETTINGCOMPLAINTRELETION,
        GETPEDIATRICOPDSETTINGPAINASSESSMENT,
        GETALLPEDIATRICOPDSETTINGCOMPLAINT,
        CREATEPEDIATRICOPDSETTINGEXAMINATIONNUTRITION,
        GETPEDIATRICOPDSETTINGEXAMINATIONNUTRITION,
        DELETEPEDIATRICOPDSETTINGEXAMINATIONNUTRITION,
        UPDATEPEDIATRICOPDSETTINGEXAMINATIONNUTRITION,
        CREATEPEDIATRICOPDSETTINGEXAMINATIONANAEMIA,
        GETPEDIATRICOPDSETTINGEXAMINATIONANAEMIA,
        DELETEPEDIATRICOPDSETTINGEXAMINATIONANAEMIA,
        UPDATEPEDIATRICOPDSETTINGEXAMINATIONANAEMIA,
        CREATEPEDIATRICOPDSETTINGEXAMINATIONNECKVAIN,
        GETPEDIATRICOPDSETTINGEXAMINATIONNECKVAIN,
        DELETEPEDIATRICOPDSETTINGEXAMINATIONNECKVAIN,
        UPDATEPEDIATRICOPDSETTINGEXAMINATIONNECKVAIN,
        CREATEPEDIATRICOPDSETTINGEXAMINATIONLYMPHNODES,
        GETPEDIATRICOPDSETTINGEXAMINATIONLYMPHNODES,
        DELETEPEDIATRICOPDSETTINGEXAMINATIONLYMPHNODES,
        UPDATEPEDIATRICOPDSETTINGEXAMINATIONLYMPHNODES,
} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

        switch (action.type) {
                case CREATEPEDIATRICOPDSETTINGEXAMINATIONLYMPHNODES:
                        return {
                                ...state,
                                pediatricopdsettingexaminationlymphnodesSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGEXAMINATIONLYMPHNODES:
                        return {
                                ...state,
                                pediatricopdsettingexaminationlymphnodesList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGEXAMINATIONLYMPHNODES:
                        return {
                                ...state,
                                pediatricopdsettingexaminationlymphnodesUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGEXAMINATIONLYMPHNODES:
                        return {
                                ...state,
                                pediatricopdsettingexaminationlymphnodesDeleteStatus: action.payload.success,
                        }

                case CREATEPEDIATRICOPDSETTINGEXAMINATIONNECKVAIN:
                        return {
                                ...state,
                                pediatricopdsettingexaminationneckvainSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGEXAMINATIONNECKVAIN:
                        return {
                                ...state,
                                pediatricopdsettingexaminationneckvainList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGEXAMINATIONNECKVAIN:
                        return {
                                ...state,
                                pediatricopdsettingexaminationneckvainUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGEXAMINATIONNECKVAIN:
                        return {
                                ...state,
                                pediatricopdsettingexaminationneckvainDeleteStatus: action.payload.success,
                        }

                case CREATEPEDIATRICOPDSETTINGEXAMINATIONANAEMIA:
                        return {
                                ...state,
                                pediatricopdsettingexaminationanaemiaSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGEXAMINATIONANAEMIA:
                        return {
                                ...state,
                                pediatricopdsettingexaminationanaemiaList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGEXAMINATIONANAEMIA:
                        return {
                                ...state,
                                pediatricopdsettingexaminationanaemiaUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGEXAMINATIONANAEMIA:
                        return {
                                ...state,
                                pediatricopdsettingexaminationanaemiaDeleteStatus: action.payload.success,
                        }

                case CREATEPEDIATRICOPDSETTINGEXAMINATIONNUTRITION:
                        return {
                                ...state,
                                pediatricopdsettingexaminationnutritionSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGEXAMINATIONNUTRITION:
                        return {
                                ...state,
                                pediatricopdsettingexaminationnutritionList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGEXAMINATIONNUTRITION:
                        return {
                                ...state,
                                pediatricopdsettingexaminationnutritionUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGEXAMINATIONNUTRITION:
                        return {
                                ...state,
                                pediatricopdsettingexaminationnutritionDeleteStatus: action.payload.success,
                        }

                case CREATEPEDIATRICOPDSETTINGPAINASSESSMENTSTATUS:
                        return {
                                ...state,
                                pediatricopdsettingpainassesmentstatusSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGPAINASSESSMENTSTATUS:
                        return {
                                ...state,
                                pediatricopdsettingpainassesmentstatusList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTSTATUS:
                        return {
                                ...state,
                                pediatricopdsettingpainassesmentstatusUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGPAINASSESSMENTSTATUS:
                        return {
                                ...state,
                                pediatricopdsettingpainassesmentstatusDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICOPDSETTINGPAINASSESSMENTSEVERITY:
                        return {
                                ...state,
                                pediatricopdsettingpainassesmentstatusSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGPAINASSESSMENTSEVERITY:
                        return {
                                ...state,
                                pediatricopdsettingpainassesmentseverityList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTSEVERITY:
                        return {
                                ...state,
                                pediatricopdsettingpainassesmentseverityUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGPAINASSESSMENTSEVERITY:
                        return {
                                ...state,
                                pediatricopdsettingpainassesmentseverityDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINNATURE:
                        return {
                                ...state,
                                pediatricopdsettingpainassesmentpainnatureSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGPAINASSESSMENTPAINNATURE:
                        return {
                                ...state,
                                pediatricopdsettingpainassesmentpainnatureList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINNATURE:
                        return {
                                ...state,
                                pediatricopdsettingpainassesmentpainnatureUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGPAINASSESSMENTPAINNATURE:
                        return {
                                ...state,
                                pediatricopdsettingpainassesmentpainnatureDeleteStatus: action.payload.success,
                        }

                case CREATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINONSET:
                        return {
                                ...state,
                                pediatricopdsettingpainassesmentpainonsetSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGPAINASSESSMENTPAINONSET:
                        return {
                                ...state,
                                pediatricopdsettingpainassesmentpainonsetList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINONSET:
                        return {
                                ...state,
                                pediatricopdsettingpainassesmentpainonsetUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGPAINASSESSMENTPAINONSET:
                        return {
                                ...state,
                                pediatricopdsettingpainassesmentpainonsetDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINVARIATION:
                        return {
                                ...state,
                                pediatricopdsettingpainassesmentpainvariationSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGPAINASSESSMENTPAINVARIATION:
                        return {
                                ...state,
                                pediatricopdsettingpainassesmentpainvariationList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINVARIATION:
                        return {
                                ...state,
                                pediatricopdsettingpainassesmentpainvariationUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGPAINASSESSMENTPAINVARIATION:
                        return {
                                ...state,
                                pediatricopdsettingpainassesmentpainvariationDeleteStatus: action.payload.success,
                        }

                case CREATEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRY:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorysystemicenquirySaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRY:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorysystemicenquiryList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRY:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorysystemicenquiryUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRY:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorysystemicenquiryDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRYTYPE:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorysystemicenquirytypeSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRYTYPE:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorysystemicenquirytypeList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRYTYPE:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorysystemicenquirytypeUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRYTYPE:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorysystemicenquirytypeDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICOPDSETTINGCOMPLAINTSILLNESSDURINGPEGNANCY:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistoryillnessduringpregnancySaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGCOMPLAINTSILLNESSDURINGPEGNANCY:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistoryillnessduringpregnancyList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGCOMPLAINTSILLNESSDURINGPEGNANCY:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistoryillnessduringpregnancyUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGCOMPLAINTSILLNESSDURINGPEGNANCY:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistoryillnessduringpregnancyDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICOPDSETTINGCOMPLAINTSINFECTIONDURINGPEGNANCY:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistoryinfectionsduringpregnancySaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGCOMPLAINTSINFECTIONDURINGPEGNANCY:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistoryinfectionsduringpregnancyList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGCOMPLAINTSINFECTIONDURINGPEGNANCY:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistoryiNFECTIONsduringpregnancyUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGCOMPLAINTSINFECTIONDURINGPEGNANCY:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistoryiNFECTIONsduringpregnancyDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICOPDSETTINGEXAMINATIONGENERALAPPEARANCE:
                        return {
                                ...state,
                                pediatricopdsettingexaminationgeneralappearanceSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGEXAMINATIONGENERALAPPEARANCE:
                        return {
                                ...state,
                                pediatricopdsettingexaminationgeneralappearanceList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGEXAMINATIONGENERALAPPEARANCE:
                        return {
                                ...state,
                                pediatricopdsettingexaminationgeneralappearanceUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGEXAMINATIONGENERALAPPEARANCE:
                        return {
                                ...state,
                                pediatricopdsettingexaminationgeneralappearanceDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICOPDSETTINGCOMPLAINTDELIVERYTYPE:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorytypeofdeliverySaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGCOMPLAINTDELIVERYTYPE:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorytypeofdeliveryList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGCOMPLAINTDELIVERYTYPE:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorytypeofdeliveryUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGCOMPLAINTDELIVERYTYPE:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorytypeofdeliveryDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICOPDSETTINGCOMPLAINTFIRSTCRY:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorytypeoffirstcrySaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGCOMPLAINTFIRSTCRY:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorytypeoffirstcryList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGCOMPLAINTFIRSTCRY:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorytypeoffirstcryUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGCOMPLAINTFIRSTCRY:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorytypeoffirstcryDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICOPDSETTINGCOMPLAINTBASICPROBLEM:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorybasicproblemSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGCOMPLAINTBASICPROBLEM:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorybasicproblemsList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGCOMPLAINTBASICPROBLEM:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorybasicproblemUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGCOMPLAINTBASICPROBLEM:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorybasicproblemDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICOPDSETTINGCOMPLAINTPROCEDURES:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistoryproceduresSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGCOMPLAINTPROCEDURES:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistoryproceduresList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGCOMPLAINTPROCEDURES:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistoryproceduresUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGCOMPLAINTPROCEDURES:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistoryproceduresDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICOPDSETTINGCOMPLAINTFEEDINGSUPPLEMENT:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistoryfeedingsupplementsSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGCOMPLAINTFEEDINGSUPPLEMENT:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistoryfeedingsupplementsList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGCOMPLAINTFEEDINGSUPPLEMENT:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistoryfeedingsupplementsUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGCOMPLAINTFEEDINGSUPPLEMENT:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistoryfeedingsupplementsDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICOPDSETTINGCOMPLAINTMILESTONEAGEGROUP:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorymilestoneagegroupSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGCOMPLAINTMILESTONEAGEGROUP:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorymilestoneagegroupList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGCOMPLAINTMILESTONEAGEGROUP:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorymilestoneagegroupUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGCOMPLAINTMILESTONEAGEGROUP:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorymilestoneagegroupDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICOPDSETTINGCOMPLAINTMILESTONE:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorymilestoneSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGCOMPLAINTMILESTONE:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorymilestoneList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGCOMPLAINTMILESTONE:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorymilestoneUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGCOMPLAINTMILESTONE:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorymilestoneDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICOPDSETTINGCOMPLAINTPASTILLNESSES:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorypastillnessesSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGCOMPLAINTPASTILLNESSES:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorypastillnessesList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGCOMPLAINTPASTILLNESSES:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorypastillnessesUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGCOMPLAINTPASTILLNESSES:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorypastillnessesDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICOPDSETTINGCOMPLAINTDIET:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorydietSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGCOMPLAINTDIET:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorydietList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGCOMPLAINTDIET:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorydietUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGCOMPLAINTDIET:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorydietDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICOPDSETTINGCOMPLAINTAPPETITE:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistoryappetiteSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGCOMPLAINTAPPETITE:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistoryappetiteList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGCOMPLAINTAPPETITE:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistoryappetiteUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGCOMPLAINTAPPETITE:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistoryappetiteDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICOPDSETTINGCOMPLAINTDIGESTIVETRACT:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorydigestivetractSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGCOMPLAINTDIGESTIVETRACT:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorydigestivetractList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGCOMPLAINTDIGESTIVETRACT:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorydigestivetractUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGCOMPLAINTDIGESTIVETRACT:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorydigestivetractDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICOPDSETTINGCOMPLAINTBOWEL:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorybowelSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGCOMPLAINTBOWEL:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorybowelList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGCOMPLAINTBOWEL:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorybowelUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGCOMPLAINTBOWEL:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorybowelDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICOPDSETTINGCOMPLAINTSLIP:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistoryslipSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGCOMPLAINTSLIP:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistoryslipList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGCOMPLAINTSLIP:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistoryslipUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGCOMPLAINTSLIP:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistoryslipDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICOPDSETTINGCOMPLAINTPOSITIONDURINGWORK:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorypositionduringworkSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGCOMPLAINTPOSITIONDURINGWORK:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorypositionduringworkList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGCOMPLAINTPOSITIONDURINGWORK:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorypositionduringworkUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGCOMPLAINTPOSITIONDURINGWORK:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorypositionduringworkDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICOPDSETTINGCOMPLAINTNATURE:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorynatureSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGCOMPLAINTNATURE:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorynatureList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGCOMPLAINTNATURE:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorynatureUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGCOMPLAINTNATURE:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistorynatureDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICOPDSETTINGCOMPLAINTRELETION:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistoryreletionSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGCOMPLAINTRELETION:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistoryreletionList: action.payload.data,
                        }
                case UPDATEPEDIATRICOPDSETTINGCOMPLAINTRELETION:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistoryreletionUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICOPDSETTINGCOMPLAINTRELETION:
                        return {
                                ...state,
                                pediatricopdsettingcomplenthistoryreletionDeleteStatus: action.payload.success,
                        }
                case GETPEDIATRICOPDSETTINGPAINASSESSMENT:
                        return {
                                ...state,
                                allpediatricopdsettingpainassesmentList: action.payload.data,
                        }
                case GETALLPEDIATRICOPDSETTINGCOMPLAINT:
                        return {
                                ...state,
                                allpediatricopdsettingcomplaintList: action.payload.data,
                        }
                case GETALLPEDIATRICOPDSETTINGINVESTIGATION:
                        return {
                                ...state,
                                allpediatricopdsettinginvestigationList: action.payload.data,
                        }
                default:
                        return state
        }
}